import { Component, computed, ElementRef, HostListener, viewChild, viewChildren } from '@angular/core';
import { PropsServiceService } from '../../props-service.service';
import { KopConfigService } from '../../../core/kop-config.service';
import { FocusManagerService } from '../../../keynav/focus-manager.service';
import { AIEditorComponent } from '../../aieditor/aieditor.component';
import { isElementVisibleInContainer } from '../../../utils/utils';
import { BaseElementComponent } from '../../../keynav/base-element/base-element.component';
import { BaseListComponent } from '../../../keynav/base-list/base-list.component';

@Component({
  selector: 'klassiek-ai',
  templateUrl: './klassiek-ai.component.html',
  styles: `
    .button {
    width: 100%;
  }
  .wrapper {
    max-height: 600px;
  }
  .splitter {
    border-bottom: 1px solid black;
    margin: 3px 0px 3px 0px;
    width: 100%;
  }
  `
})
export class KlassiekAiComponent extends BaseListComponent {

  constructor(public propsService: PropsServiceService, public kopConfigService: KopConfigService, elementRef: ElementRef<HTMLElement>, focusManager: FocusManagerService) {
    super(elementRef,focusManager);
    this.keyProperty = "klassiek-ai";
  }

  public availableAIs = computed(() => {
    let currentAis = this.propsService.ais();
    let aiMetas = this.kopConfigService.currentMeta().ais;
    let metas = aiMetas.filter(ai => !currentAis.find(a => a.index == ai.index)).sort((a1, a2) => {
      return a1.omschrij.toString().localeCompare(a2.omschrij.toString());
    });
    let ret = metas.map(m => {
      return this.kopConfigService.aiKCtoModule(m.index, undefined);
    });
    return ret;
  });


  @HostListener('window:keydown.alt.a', ['$event'])
  shortcut(event: Event) {
    this.open();
  }


  public aiEditors = viewChildren(AIEditorComponent);
  public getChildren():readonly  BaseElementComponent[] {
    return this.aiEditors();  
  }

  public container = viewChild<ElementRef<HTMLDivElement>>('container');

}
